import {
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  Radio,
  RadioGroup,
} from "@mui/material";
import React, { useState } from "react";
import BatchMultiSelect from "reuseableTable/autoCompleteMultiSelect/BatchMultiSelect";
import BranchMultiSelect from "reuseableTable/autoCompleteMultiSelect/BranchMultiSelect";
import GroupMultiSelect from "reuseableTable/autoCompleteMultiSelect/GroupMultiSelect";
import GroupMultiSelectforAlumni from "reuseableTable/autoCompleteMultiSelect/GroupMultiSelectforAlumni";

const InviteTo = ({
  values,
  handleChange,
  setSelectedBatchs,
  setSelectedGroups,
  setSelectedBranchs,
  selectedBatchs,
  selectedGroups,
  selectedBranchs,
  setFieldValue,
  formikRef,
  instituteDetails,
  alumngroup,
  setSelectedBranchForIds,
  selectedBranchForIds,
  type,
}) => {
  const getRole = localStorage.getItem("role");

  const handleRadioChange = (event) => {
    const { value } = event.target;
    setFieldValue("eventFor", value);
    setFieldValue("eventForBranchIds", []);
  };

  const handleGroupChange = (newSelectedGroups) => {
    setSelectedGroups(newSelectedGroups);

    const selected = newSelectedGroups?.map((data) => data?.id);
    setFieldValue("eventForIds", selected);
  };

  const handleBatchChange = (newSelectedGroups) => {
    setSelectedBatchs(newSelectedGroups);
    const selected = newSelectedGroups?.map((data) => data?.id);
    setFieldValue("eventForIds", selected);
  };

  const handleBranchChange = (newSelectedGroups) => {
    setSelectedBranchs(newSelectedGroups);
    const selected = newSelectedGroups?.map((data) => data?.id);
    setFieldValue("eventForIds", selected);
  };

  const handleBranchChangeIds = (newSelectedGroups) => {
    setSelectedBranchForIds(newSelectedGroups);
    const selected = newSelectedGroups?.map((data) => data?.id);
    setFieldValue("eventForBranchIds", selected);
  };

  return (
    <>
      <Grid container spacing={1}>
        <Grid item md={12} xs={12}>
          <FormControl>
            <FormLabel id="demo-row-radio-buttons-group-label">
              <Grid item md={12} xs={12} />
            </FormLabel>
            <RadioGroup
              row
              aria-labelledby="demo-row-radio-buttons-group-label"
              name="row-radio-buttons-group"
              value={values.eventFor}
              onChange={handleRadioChange}
            >
              <FormControlLabel
                value="Group"
                control={<Radio />}
                label="Group"
              />
              <FormControlLabel
                value="Batch"
                control={<Radio />}
                label="Batch"
              />
              <FormControlLabel
                value="EveryOne"
                control={<Radio />}
                label="EveryOne"
              />
              {instituteDetails?.branchEnabled &&
                getRole !== "ROLE_ALUMNI" &&
                type !== "INSTITUTESUBADMIN" && (
                  <FormControlLabel
                    value="Branch"
                    // disabled
                    control={<Radio />}
                    label="Branch"
                  />
                )}
            </RadioGroup>
          </FormControl>
        </Grid>

        {values?.eventFor === "Group" && (
          <>
            {!alumngroup ? (
              <>
                <Grid item md={12} xs={6}>
                  <GroupMultiSelect
                    setSelectedBatchs={setSelectedBatchs}
                    setSelectedGroups={setSelectedGroups}
                    value={selectedGroups}
                    setFieldValue={setFieldValue}
                    onChange={handleGroupChange}
                    label="Select Groups"
                  />
                </Grid>
              </>
            ) : (
              <>
                <Grid item md={12} xs={6}>
                  <GroupMultiSelectforAlumni
                    setSelectedBatchs={setSelectedBatchs}
                    setSelectedGroups={setSelectedGroups}
                    value={selectedGroups}
                    setFieldValue={setFieldValue}
                    onChange={handleGroupChange}
                    label="Select Groups"
                  />
                </Grid>
              </>
            )}
          </>
        )}
        {values?.eventFor === "Batch" && (
          <>
            <Grid item md={6} xs={12}>
              <BatchMultiSelect
                setSelectedBatchs={setSelectedBatchs}
                value={selectedBatchs}
                setFieldValue={setFieldValue}
                onChange={handleBatchChange}
                label="Select Batch"
              />
            </Grid>
            {instituteDetails?.branchEnabled && getRole !== "ROLE_ALUMNI" && (
              <Grid item md={6} xs={12}>
                <BranchMultiSelect
                  instituteDetails={instituteDetails}
                  setSelectedBranchs={setSelectedBranchForIds}
                  value={selectedBranchForIds}
                  setFieldValue={setFieldValue}
                  onChange={handleBranchChangeIds}
                  label="Select Branch"
                />
              </Grid>
            )}
          </>
        )}
        {values?.eventFor === "Branch" && getRole !== "ROLE_ALUMNI" && (
          <Grid item md={12} xs={6}>
            <BranchMultiSelect
              setSelectedBranchs={setSelectedBranchs}
              value={selectedBranchs}
              setFieldValue={setFieldValue}
              onChange={handleBranchChange}
              label="Select Branch"
            />
          </Grid>
        )}
      </Grid>
    </>
  );
};

export default InviteTo;
